import { SuspensePageBoundary } from "@-/dev.improve.haniverse.components.ui.suspense-page";
import { MorphemeInfoPanelLoadingView } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._components.panel-content";
import { WordMorphemePanelsView } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._views.word";
import type { ReactNode } from "react";

/** A word's info view as a standalone card surface; see `GraphemeInfoFlashcardSurface`. */
export function WordInfoFlashcardSurface({
  children,
  word,
}: {
  children?: ReactNode;
  word: string;
}) {
  return (
    <SuspensePageBoundary
      fallback={<MorphemeInfoPanelLoadingView />}
      location={import.meta.location}
    >
      <WordMorphemePanelsView word={word} />
      {children}
    </SuspensePageBoundary>
  );
}
